var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex h-100"},[_c('client-contact-history',{attrs:{"contacts":_vm.contacts,"outreach-events":_vm.outreachEvents,"customer":_vm.customer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }